module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Требуется ввести код с картинки.":"Captcha is required.","Логин или email":"Username or e-mail","Вход":"Log in","Код с картинки":"Code from picture","Пароль":"Password","Войти":"Log in","Авторизация...":"Logging in...","Восстановить пароль":"Remember password","Регистрация":"Registration","Код из приложения Authenticator":"Code from Authenticator app","Код":"Verification code"}}')
  delete Component.options._Ctor
}
